// Globals and Element Declarations
let productData = {};
const summaryWrapper = document.querySelector(
  ".product__subscription-review--summary"
);
const url = new URL(window.location.href);
const summaryOverlay = document.querySelector(".subscription-review__overlay");

const resolveDeliveryType = () => {
  const selected = document.querySelector(
    `input[name="selling_plan_group"]:checked`
  );
  const frequency = document.querySelector(
    'input[name="selling_plan_frequency"]:checked + label'
  );
  if (selected.getAttribute("data-target") === "ongoing") {
    return `${frequency.innerText} (recurring payment)`;
  } else {
    const duration = document.querySelector(
      'input[name="selling_plan_type"]:checked + label'
    );
    return `${frequency.innerText} for ${duration.innerText}`.toLowerCase();
  }
};

const resolveSummaryDescription = (option, index) => {
  const descriptions = [`${option} of coffee`, `${option} coffee`, `${option}`];
  return descriptions[index];
};

const findVariant = (variantID) => {
  const matchingVariant = productData?.variants?.filter(({ id }) => {
    return id == variantID;
  });
  return matchingVariant ? matchingVariant[0] : false;
};

const findSellingPlan = (sellingPlanID) => {
  //Merge the array
  let matchingSellingPlan = "";
  let breakLoop = false;
  productData?.selling_plan_groups?.forEach(({ selling_plans }) => {
    if (!breakLoop) {
      selling_plans.forEach((selling_plan) => {
        if (selling_plan.id == sellingPlanID) {
          matchingSellingPlan = selling_plan;
          breakLoop = true;
          return;
        }
      });
    }
    return;
  });
  return matchingSellingPlan;
};

const renderSubscriptionVariants = (variant, p, options, sellingPlan) => {
  summaryOverlay.classList.add("active");
  summaryWrapper.innerHTML = "";
  options?.map((option, index) => {
    let li = document.createElement("li");
    li.appendChild(
      document.createTextNode(resolveSummaryDescription(option, index))
    );
    summaryWrapper.appendChild(li);
  });

  //Add Grind Type
  const grind = document.querySelector('select[name="Grind"]');

  if (grind) {
    let li = document.createElement("li");
    li.appendChild(document.createTextNode(grind?.value));
    summaryWrapper.appendChild(li);
  }

  //Add Delivery Frequency

  let deliveryFrequency = document.createElement("li");
  deliveryFrequency.appendChild(
    document.createTextNode(`Delivery ${resolveDeliveryType()}`)
  );
  summaryWrapper.appendChild(deliveryFrequency);

  //Add Price
  let totalWrapper = document.createElement("li");
  let totalCost = document.createElement("span");
  let totalMessage = document.createElement("span");

  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  });

  const variantSellingPlan = variant.selling_plan_allocations.filter(
    ({ selling_plan_id, price, per_delivery_price }) => {
      return selling_plan_id === sellingPlan.id;
    }
  );

  totalCost.appendChild(
    document.createTextNode(
      formatter.format(variantSellingPlan[0]?.price / 100)
    )
  );
  totalMessage.appendChild(
    document.createTextNode(
      variantSellingPlan[0].per_delivery_price === variantSellingPlan[0].price
        ? "per delivery"
        : "one time payment"
    )
  );
  totalWrapper.appendChild(totalCost);
  totalWrapper.appendChild(totalMessage);
  summaryWrapper.appendChild(totalWrapper);

  setTimeout(() => {
    summaryOverlay.classList.remove("active");
  }, 500);
};

fetch(`${url.pathname}.js`)
  .then((res) => res.json())
  .then((data) => {
    productData = data;
  })
  .finally(() => {
    const productForm = document.querySelector(
      "product-form .product-form__selling-variant-ids"
    );
    const logMutations = function (mutations, observer) {
      const variant = findVariant(
        productForm.querySelector('input[name="id"]').value
      );
      const sellingPlan = findSellingPlan(
        productForm.querySelector('input[name="selling_plan"]').value
      );
      renderSubscriptionVariants(
        variant,
        variant.price,
        variant.options,
        sellingPlan
      );
    };
    const observer = new MutationObserver(logMutations);
    observer.observe(productForm, {
      childList: true,
      attributes: true,
      subtree: true,
    });
  });
